import { useState } from "react";
import { localDateTime } from "../../lib/datetime";
import { useTranslation } from "react-i18next";
import { QRCodeCanvas } from "qrcode.react";
import { Copy, QrCode, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { deleteInvitation } from "../../api/onboarding";
import { NeuButton } from "../../components/neu/Neu";

const WEB_BASE = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
const joinUrl = (token) => `${WEB_BASE}/join/${token}`;

export const InviteList = ({ invites, reload }) => {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(null);

  if (invites.length === 0) return <p className="text-sm text-muted-foreground">{t("invites.empty")}</p>;

  return (
    <ul className="mt-5 space-y-3" data-testid="invite-list">
      {invites.map((inv) => (
        <li
          key={inv.id}
          data-testid={`invite-row-${inv.id}`}
          className="rounded-2xl border border-border/50 px-4 py-3 shadow-neu-sm"
        >
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span className="text-sm font-semibold">{inv.email}</span>
            <span className="font-mono text-[11px] text-muted-foreground">{t(`roles.${inv.role}`)}</span>
            <span className="font-mono text-[11px] text-muted-foreground">
              {t("invites.expires")}: {localDateTime(inv.expires_at)}
            </span>
            <span className={`text-xs font-bold ${inv.used ? "text-muted-foreground" : "text-success"}`}>
              {inv.used ? t("invites.used") : t("invites.pending")}
            </span>
            <div className="flex gap-2">
              <NeuButton
                className="px-3 py-2"
                data-testid={`invite-qr-${inv.id}`}
                onClick={() => setOpenId(openId === inv.id ? null : inv.id)}
              >
                <QrCode className="h-4 w-4" />
              </NeuButton>
              <NeuButton
                className="px-3 py-2"
                data-testid={`invite-copy-${inv.id}`}
                onClick={() => {
                  navigator.clipboard?.writeText(joinUrl(inv.token));
                  toast.success(t("invites.copied"));
                }}
              >
                <Copy className="h-4 w-4" />
              </NeuButton>
              <NeuButton
                variant="danger"
                className="px-3 py-2"
                data-testid={`invite-delete-${inv.id}`}
                onClick={async () => {
                  await deleteInvitation(inv.id);
                  reload();
                }}
              >
                <Trash2 className="h-4 w-4" />
              </NeuButton>
            </div>
          </div>
          {openId === inv.id ? (
            <div className="mt-4 flex flex-col items-center gap-3" data-testid={`invite-qr-box-${inv.id}`}>
              <div className="rounded-2xl bg-white p-3 shadow-neu-sm">
                <QRCodeCanvas value={joinUrl(inv.token)} size={168} includeMargin={false} />
              </div>
              <code className="break-all text-center font-mono text-[11px] text-primary">{joinUrl(inv.token)}</code>
            </div>
          ) : null}
        </li>
      ))}
    </ul>
  );
};
